import React from 'react';
import { cn } from '../../../lib/utils';

export interface TaskyTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  hasError?: boolean;
}

export const TaskyTextarea = React.forwardRef<HTMLTextAreaElement, TaskyTextareaProps>(
  ({ className, hasError, disabled, rows = 4, ...rest }, ref) => (
    <textarea
      ref={ref}
      rows={rows}
      {...rest}
      disabled={disabled}
      className={cn(
        'w-full px-3 py-2 text-base text-dark placeholder:text-gray-400',
        'bg-white border border-warm-border rounded-tasky-sm transition-colors resize-y',
        'focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary',
        hasError && 'border-destructive focus:ring-destructive/30 focus:border-destructive',
        disabled && 'bg-gray-100 text-gray-500 cursor-not-allowed',
        className,
      )}
    />
  ),
);
TaskyTextarea.displayName = 'TaskyTextarea';
